import lightGallery from 'lightgallery';
import 'lightgallery/css/lightgallery.css'; // Core CSS for lightGallery

// Single-image lightbox.
//
// Any element with the `.lightbox-item` class (an <a> wrapping an image)
// opens its full-size image — the anchor's href — in a lightGallery popup.
//
// We use event delegation instead of initialising lightGallery directly on
// the slider containers. The sliders run with Swiper's `loop: true`, which
// clones slides (`.swiper-slide-duplicate`). Delegation means clicks on the
// cloned slides work too, and each click opens just that one image with no
// next/previous navigation (single-image mode).
document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('click', function (event) {
        const trigger = event.target.closest('.lightbox-item');
        if (!trigger) {
            return;
        }

        event.preventDefault();

        const fullSrc = trigger.getAttribute('href');
        if (!fullSrc || fullSrc === '#') {
            return;
        }

        const img = trigger.querySelector('img');
        const alt = img ? img.getAttribute('alt') : '';

        // Throwaway container used only to drive this popup instance.
        const container = document.createElement('div');
        document.body.appendChild(container);

        const gallery = lightGallery(container, {
            dynamic: true,
            dynamicEl: [{ src: fullSrc, thumb: fullSrc, alt: alt }],
            counter: false,
            download: true,
            licenseKey: '0000-0000-000-0000',
        });

        gallery.openGallery(0);

        // Tear the instance down once the popup closes so repeated clicks
        // don't stack up detached containers/instances.
        container.addEventListener('lgAfterClose', function () {
            gallery.destroy();
            container.remove();
        });
    });
});
